import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.focused = localStorage.getItem("table_focus") === "true"
    this._apply()
  }

  toggle() {
    this.focused = !this.focused
    localStorage.setItem("table_focus", this.focused)
    this._apply()
  }

  _apply() {
    this.element.querySelectorAll("[data-focus-hide]").forEach(el => {
      el.classList.toggle("hidden", this.focused)
    })

    if (this.hasToggleTarget) {
      this.toggleTarget.classList.toggle("bg-page", this.focused)
    }
  }
}
